var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/user/outline/user"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 255",
    cx: 14.0007,
    cy: 20.4779,
    rx: 8.16667,
    ry: 4.08333,
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 257",
    cx: 14.0007,
    cy: 8.22917,
    r: 4.66667,
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/about-icon.c1134d15b9626f238380a16c569b092b.svg";
export { ForwardRef as ReactComponent };